import { useEffect, useRef } from "react";
import { InvoiceFormData } from "@/types";

export function useBankAccountFieldEffects({
    bankAccountWatch,
    missingBankAccount,
    setMissingBankAccount,
    isFormChanged,
    setChangedCurrency,
    setPreviousCurrency,
    previousCurrency
}: {
    bankAccountWatch: InvoiceFormData["bankAccount"];
    missingBankAccount: string | undefined;
    setMissingBankAccount: React.Dispatch<React.SetStateAction<string | undefined>>;
    isFormChanged: boolean;
    setChangedCurrency: React.Dispatch<React.SetStateAction<boolean>>;
    setPreviousCurrency: React.Dispatch<React.SetStateAction<string | undefined>>;
    previousCurrency: string | undefined;
}) {
    const hasBaselineCurrency = useRef(false);

    // initial currency
    useEffect(() => {
        const currency = bankAccountWatch?.currency?.trim?.();

        if (!hasBaselineCurrency.current && currency) {
            hasBaselineCurrency.current = true;
            setPreviousCurrency(currency);
        }
    }, [bankAccountWatch?.currency, setPreviousCurrency]);

    // changes to currency
    useEffect(() => {
        const currency = bankAccountWatch?.currency?.trim?.();

        if (!hasBaselineCurrency.current || !isFormChanged || !currency || !previousCurrency) {
            return;
        }

        if (currency !== previousCurrency) {
            setChangedCurrency(true);
            setPreviousCurrency(currency);
        }

        if (missingBankAccount) {
            setMissingBankAccount(undefined);
        }
    }, [
        bankAccountWatch?.currency,
        isFormChanged,
        previousCurrency,
        missingBankAccount,
        setChangedCurrency,
        setPreviousCurrency,
        setMissingBankAccount
    ]);
}
